var _rect, _mask, _path, _path2, _mask2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17363,
    y: 3.71318,
    width: 27.6271,
    height: 22.887,
    rx: 4.9,
    fill: "url(#paint0_linear_1134_5350)",
    stroke: "#4F5163",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1134_5350",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38965 1.3599C8.38965 0.995556 8.68501 0.700195 9.04935 0.700195C9.4137 0.700195 9.70906 0.995556 9.70906 1.3599V4.16976H8.38965V1.3599Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38965 1.3599C8.38965 0.995556 8.68501 0.700195 9.04935 0.700195C9.4137 0.700195 9.70906 0.995556 9.70906 1.3599V4.16976H8.38965V1.3599Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70906 4.16976V5.56976H11.1091V4.16976H9.70906ZM8.38965 4.16976H6.98965V5.56976H8.38965V4.16976ZM8.30906 1.3599V4.16976H11.1091V1.3599H8.30906ZM9.70906 2.76976H8.38965V5.56976H9.70906V2.76976ZM9.78965 4.16976V1.3599H6.98965V4.16976H9.78965ZM9.04935 2.1002C8.6405 2.1002 8.30906 1.76875 8.30906 1.3599H11.1091C11.1091 0.222358 10.1869 -0.699805 9.04935 -0.699805V2.1002ZM9.04935 -0.699805C7.91181 -0.699805 6.98965 0.222357 6.98965 1.3599H9.78965C9.78965 1.76875 9.45821 2.1002 9.04935 2.1002V-0.699805Z",
    fill: "#4F5163",
    mask: "url(#path-2-inside-1_1134_5350)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1134_5350",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 1.3599C20.2637 0.995556 20.559 0.700195 20.9234 0.700195C21.2877 0.700195 21.5831 0.995556 21.5831 1.3599V4.16976H20.2637V1.3599Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 1.3599C20.2637 0.995556 20.559 0.700195 20.9234 0.700195C21.2877 0.700195 21.5831 0.995556 21.5831 1.3599V4.16976H20.2637V1.3599Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5831 4.16976V5.56976H22.9831V4.16976H21.5831ZM20.2637 4.16976H18.8637V5.56976H20.2637V4.16976ZM20.1831 1.3599V4.16976H22.9831V1.3599H20.1831ZM21.5831 2.76976H20.2637V5.56976H21.5831V2.76976ZM21.6637 4.16976V1.3599H18.8637V4.16976H21.6637ZM20.9234 2.1002C20.5145 2.1002 20.1831 1.76875 20.1831 1.3599H22.9831C22.9831 0.222358 22.0609 -0.699805 20.9234 -0.699805V2.1002ZM20.9234 -0.699805C19.7858 -0.699805 18.8637 0.222357 18.8637 1.3599H21.6637C21.6637 1.76875 21.3322 2.1002 20.9234 2.1002V-0.699805Z",
    fill: "#4F5163",
    mask: "url(#path-4-inside-2_1134_5350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45 10.5307C6.45 9.95919 6.91329 9.4959 7.48478 9.4959H7.97345C8.54495 9.4959 9.00824 9.95919 9.00824 10.5307C9.00824 11.1022 8.54495 11.5655 7.97345 11.5655H7.48478C6.91329 11.5655 6.45 11.1022 6.45 10.5307Z",
    fill: "#283593",
    stroke: "#4F5163",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45 17.4696C6.45 16.8982 6.91329 16.4349 7.48478 16.4349H7.97345C8.54495 16.4349 9.00824 16.8982 9.00824 17.4696C9.00824 18.0411 8.54495 18.5044 7.97345 18.5044H7.48478C6.91329 18.5044 6.45 18.0411 6.45 17.4696Z",
    fill: "#283593",
    stroke: "#4F5163",
    strokeWidth: 1.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.368 10.5307C14.368 9.95919 14.8313 9.4959 15.4028 9.4959H15.8914C16.4629 9.4959 16.9262 9.95919 16.9262 10.5307C16.9262 11.1022 16.4629 11.5655 15.8914 11.5655H15.4028C14.8313 11.5655 14.368 11.1022 14.368 10.5307Z",
    fill: "#283593",
    stroke: "#4F5163",
    strokeWidth: 1.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.368 17.4696C14.368 16.8982 14.8313 16.4349 15.4028 16.4349H15.8914C16.4629 16.4349 16.9262 16.8982 16.9262 17.4696C16.9262 18.0411 16.4629 18.5044 15.8914 18.5044H15.4028C14.8313 18.5044 14.368 18.0411 14.368 17.4696Z",
    fill: "#283593",
    stroke: "#4F5163",
    strokeWidth: 1.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.284 10.5307C22.284 9.95919 22.7473 9.4959 23.3188 9.4959H23.8074C24.3789 9.4959 24.8422 9.95919 24.8422 10.5307C24.8422 11.1022 24.3789 11.5655 23.8074 11.5655H23.3188C22.7473 11.5655 22.284 11.1022 22.284 10.5307Z",
    fill: "#283593",
    stroke: "#4F5163",
    strokeWidth: 1.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1134_5350",
    x1: 7.7304,
    y1: 9.08492,
    x2: 7.7304,
    y2: 9.08492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.f2c416c82dc4def785b6560019fb754a.svg";
export { ForwardRef as ReactComponent };